module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "_toc",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Contents"), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Intro#_idTextAnchor001"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch ParaOverride-2"
  }, [_c('a', {
    attrs: {
      "href": "#/1Herbs#_idTextAnchor002"
    }
  }, [_vm._v("Herbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/2Stones#_idTextAnchor004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/3Candles#_idTextAnchor005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/4MagRec#_idTextAnchor006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magical Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/5Div#_idTextAnchor007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divination")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/6Gods#_idTextAnchor008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gods and Goddesses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/7Invocations#_idTextAnchor009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invocations and "), _c('br'), _vm._v("Quarter Calls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/8Spells#_idTextAnchor010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spells")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/9Rituals#_idTextAnchor011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rituals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/10Recipes#_idTextAnchor012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/11Corres#_idTextAnchor013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Correspondences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/12About#_idTextAnchor014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Artist")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0